import { Company } from '../../../types/company/Company'

const accountMapQueryKeys = {
  all: [{ scope: 'accountMap' }] as const,
  lists: () => [{ ...accountMapQueryKeys.all[0], entity: 'list' }] as const,
  list: (companyId: Company['id']) => [{ ...accountMapQueryKeys.lists()[0], companyId }] as const
}

export default accountMapQueryKeys
